module.exports = __webpack_public_path__ + "static/img/84-3.63b4377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/84-3.jpg
// module id = zXda
// module chunks = 0